export type SystemIconId =
  | 'action-add_circle_outline'
  | 'action-add_to_bookmark'
  | 'action-add_to_cart'
  | 'action-add_to_favourites'
  | 'action-add'
  | 'action-added_to_bookmark'
  | 'action-attach'
  | 'action-bookmarks'
  | 'action-cart'
  | 'action-clear'
  | 'action-close'
  | 'action-copy'
  | 'action-delete_forever'
  | 'action-delete_sweep'
  | 'action-delete'
  | 'action-download_complete'
  | 'action-download'
  | 'action-edit'
  | 'action-enter'
  | 'action-favourited'
  | 'action-filter'
  | 'action-hide'
  | 'action-maximise'
  | 'action-minimise'
  | 'action-more_horizontal'
  | 'action-more_vertical'
  | 'action-open_in_full'
  | 'action-open_in_new_tab'
  | 'action-person_add'
  | 'action-person_remove'
  | 'action-redo'
  | 'action-refresh'
  | 'action-remove_circle_outline'
  | 'action-repeat'
  | 'action-save'
  | 'action-search'
  | 'action-search_no_results'
  | 'action-share'
  | 'action-show'
  | 'action-sort_by_alpha'
  | 'action-sort_up_down'
  | 'action-sort_updown'
  | 'action-sort'
  | 'action-swap'
  | 'action-toggle_off'
  | 'action-toggle_on'
  | 'action-undo'
  | 'action-upload'
  | 'business_local_company'
  | 'business-approved_liquidator'
  | 'business-business'
  | 'business-foreign_company'
  | 'business-group_of_companies'
  | 'business-limited_liability_partnership'
  | 'business-limited_partnership'
  | 'business-public_accounting_firm'
  | 'business-public_accounting'
  | 'document-certificate'
  | 'document-document'
  | 'document-folder'
  | 'document-folder_shared'
  | 'document-image'
  | 'document-media'
  | 'document-pdf'
  | 'document-print'
  | 'document-profile_tag'
  | 'document-quote'
  | 'general-account'
  | 'general-action'
  | 'general-bar_chart'
  | 'general-calendar'
  | 'general-check'
  | 'general-clock'
  | 'general-credit_card'
  | 'general-directions'
  | 'general-empty'
  | 'general-enquiry'
  | 'general-help'
  | 'general-history'
  | 'general-home'
  | 'general-info'
  | 'general-light_bulb'
  | 'general-loading'
  | 'general-location'
  | 'general-lock'
  | 'general-login'
  | 'general-mail'
  | 'general-mail_open'
  | 'general-map'
  | 'general-media'
  | 'general-message'
  | 'general-microsoft_dynamics'
  | 'general-money'
  | 'general-notification'
  | 'general-phone'
  | 'general-pie_chart'
  | 'general-plane'
  | 'general-restricted'
  | 'general-rocket'
  | 'general-settings'
  | 'general-thumbs_up'
  | 'general-timer'
  | 'general-update'
  | 'general-update_person'
  | 'general-verified_badge'
  | 'general-verified_shield'
  | 'general-walk'
  | 'general-dashboard'
  | 'industries-biotech'
  | 'industries-fnb'
  | 'industries-hotel'
  | 'navigation-arrow_back'
  | 'navigation-arrow_down'
  | 'navigation-arrow_drop_down'
  | 'navigation-arrow_drop_up'
  | 'navigation-arrow_forward'
  | 'navigation-arrow_left'
  | 'navigation-arrow_right'
  | 'navigation-arrow_up'
  | 'navigation-chevron_left'
  | 'navigation-chevron_right'
  | 'navigation-double_chevron_left'
  | 'navigation-double_chevron_right'
  | 'navigation-expand_less'
  | 'navigation-expand_more'
  | 'navigation-menu'
  | 'registry-annual_filing'
  | 'registry-charge_registration'
  | 'registry-close_a_local_company'
  | 'registry-make_changes'
  | 'registry-start_company'
  | 'registry-update_share_info'
  | 'state-error'
  | 'state-informative'
  | 'state-success'
  | 'state-warning'
  | 'tech-API'
  | 'tech-code'
  | 'tech-data_privacy'
  | 'tech-datasets'
  | 'tech-EIQ'
  | 'tech-FIQ'
  | 'tech-security'
  | 'tech-tokens'
  | 'tech-wifi_off'
  | 'tech-wifi'
  | 'toggle-checkbox_checked_fill'
  | 'toggle-checkbox_checked_outline'
  | 'toggle-checkbox_indeterminate_fill'
  | 'toggle-checkbox_indeterminate_outline'
  | 'toggle-checkbox_unchecked'
  | 'toggle-radiobutton_selected'
  | 'toggle-radiobutton_unselected'
  | 'payment-shopping_bag'
  | 'payment-empty_cart'
  | 'document-zip'
  | 'document-ppt'
  | 'general-gavel'
  | 'general-court'
  | 'general-trending_down'
  | 'action-convert'
  | 'general-event'
  | 'business-company_cancel'
  | 'business-suitcase_cancel'
  | 'document-add_doc'
  | 'document-people_profile';

export type SystemIconKey =
  | 'ActionAddCircleOutline'
  | 'ActionAddToBookmark'
  | 'ActionAddToCart'
  | 'ActionAddToFavourites'
  | 'ActionAdd'
  | 'ActionAddedToBookmark'
  | 'ActionAttach'
  | 'ActionBookmarks'
  | 'ActionCart'
  | 'ActionClear'
  | 'ActionClose'
  | 'ActionCopy'
  | 'ActionDeleteForever'
  | 'ActionDeleteSweep'
  | 'ActionDelete'
  | 'ActionDownloadComplete'
  | 'ActionDownload'
  | 'ActionEdit'
  | 'ActionEnter'
  | 'ActionFavourited'
  | 'ActionFilter'
  | 'ActionHide'
  | 'ActionMaximise'
  | 'ActionMinimise'
  | 'ActionMoreHorizontal'
  | 'ActionMoreVertical'
  | 'ActionOpenInFull'
  | 'ActionOpenInNewTab'
  | 'ActionPersonAdd'
  | 'ActionPersonRemove'
  | 'ActionRedo'
  | 'ActionRefresh'
  | 'ActionRemoveCircleOutline'
  | 'ActionRepeat'
  | 'ActionSave'
  | 'ActionSearch'
  | 'ActionSearchNoResult'
  | 'ActionShare'
  | 'ActionShow'
  | 'ActionSortByAlpha'
  | 'ActionSortUpDown'
  | 'ActionSortUpdown'
  | 'ActionSort'
  | 'ActionSwap'
  | 'ActionToggleOff'
  | 'ActionToggleOn'
  | 'ActionTransfer'
  | 'ActionUndo'
  | 'ActionUpload'
  | 'BusinessLocalCompany'
  | 'BusinessApprovedLiquidator'
  | 'BusinessBusiness'
  | 'BusinessForeignCompany'
  | 'BusinessGroupOfCompanies'
  | 'BusinessLimitedLiabilityPartnership'
  | 'BusinessLimitedPartnership'
  | 'BusinessPublicAccountingFirm'
  | 'BusinessPublicAccounting'
  | 'DocumentCertificate'
  | 'DocumentDocument'
  | 'DocumentFolder'
  | 'DocumentFolderShared'
  | 'DocumentImage'
  | 'DocumentMedia'
  | 'DocumentPdf'
  | 'DocumentPrint'
  | 'DocumentProfileTag'
  | 'DocumentQuote'
  | 'GeneralAccount'
  | 'GeneralAction'
  | 'GeneralBarChart'
  | 'GeneralCalendar'
  | 'GeneralCheck'
  | 'GeneralClock'
  | 'GeneralCreditCard'
  | 'GeneralDirections'
  | 'GeneralEmpty'
  | 'GeneralEnquiry'
  | 'GeneralHelp'
  | 'GeneralHistory'
  | 'GeneralHome'
  | 'GeneralInfo'
  | 'GeneralLightBulb'
  | 'GeneralLoading'
  | 'GeneralLocation'
  | 'GeneralLock'
  | 'GeneralLogin'
  | 'GeneralMail'
  | 'GeneralMailOpen'
  | 'GeneralMap'
  | 'GeneralMedia'
  | 'GeneralMessage'
  | 'GeneralMicrosoftDynamics'
  | 'GeneralMoney'
  | 'GeneralNotification'
  | 'GeneralPhone'
  | 'GeneralPieChart'
  | 'GeneralPlane'
  | 'GeneralRestricted'
  | 'GeneralRocket'
  | 'GeneralSettings'
  | 'GeneralThumbsUp'
  | 'GeneralTimer'
  | 'GeneralUpdate'
  | 'GeneralVerifiedBadge'
  | 'GeneralVerifiedShield'
  | 'GeneralWalk'
  | 'GeneralDashboard'
  | 'GeneralItemsCheck'
  | 'IndustriesBiotech'
  | 'IndustriesFnb'
  | 'IndustriesHotel'
  | 'NavigationArrowBack'
  | 'NavigationArrowDown'
  | 'NavigationArrowDropDown'
  | 'NavigationArrowDropUp'
  | 'NavigationArrowForward'
  | 'NavigationArrowLeft'
  | 'NavigationArrowRight'
  | 'NavigationArrowUp'
  | 'NavigationChevronLeft'
  | 'NavigationChevronRight'
  | 'NavigationDoubleChevronLeft'
  | 'NavigationDoubleChevronRight'
  | 'NavigationExpandLess'
  | 'NavigationExpandMore'
  | 'NavigationMenu'
  | 'RegistryAnnualFiling'
  | 'RegistryChargeRegistration'
  | 'RegistryCloseALocalCompany'
  | 'RegistryMakeChanges'
  | 'RegistryStartCompany'
  | 'RegistryUpdateShareInfo'
  | 'StateError'
  | 'StateInformative'
  | 'StateSuccess'
  | 'StateWarning'
  | 'TechAPI'
  | 'TechCode'
  | 'TechDataPrivacy'
  | 'TechDatasets'
  | 'TechEIQ'
  | 'TechFIQ'
  | 'TechSecurity'
  | 'TechTokens'
  | 'TechWifiOff'
  | 'TechWifi'
  | 'ToggleCheckboxCheckedFill'
  | 'ToggleCheckboxCheckedOutline'
  | 'ToggleCheckboxIndeterminateFill'
  | 'ToggleCheckboxIndeterminateOutline'
  | 'ToggleCheckboxUnchecked'
  | 'ToggleRadiobuttonSelected'
  | 'ToggleRadiobuttonUnselected'
  | 'PaymentShoppingBag'
  | 'DocumentRegisters'
  | 'GeneralPeople'
  | 'PaymentRefund'
  | 'DocumentZip'
  | 'DocumentPpt'
  | 'GeneralUpdateCheck'
  | 'GeneralGavel'
  | 'GeneralCourt'
  | 'GeneralTrendingDown'
  | 'ActionConvert'
  | 'GeneralEvent'
  | 'BusinessCompanyCancel'
  | 'BusinessSuitcaseCancel'
  | 'DocumentAddDoc'
  | 'DocumentPeopleProfile';

export enum SystemIcon {
  ActionAddCircleOutline = 'action-add_circle_outline',
  ActionAddToBookmark = 'action-add_to_bookmark',
  ActionAddToCart = 'action-add_to_cart',
  ActionAddToFavourites = 'action-add_to_favourites',
  ActionAdd = 'action-add',
  ActionAddedToBookmark = 'action-added_to_bookmark',
  ActionAttach = 'action-attach',
  ActionBookmarks = 'action-bookmarks',
  ActionCart = 'action-cart',
  ActionClear = 'action-clear',
  ActionClose = 'action-close',
  ActionCopy = 'action-copy',
  ActionDeleteForever = 'action-delete_forever',
  ActionDeleteSweep = 'action-delete_sweep',
  ActionDelete = 'action-delete',
  ActionDownloadComplete = 'action-download_complete',
  ActionDownload = 'action-download',
  ActionEdit = 'action-edit',
  ActionEnter = 'action-enter',
  ActionFavourited = 'action-favourited',
  ActionFilter = 'action-filter',
  ActionHide = 'action-hide',
  ActionMaximise = 'action-maximise',
  ActionMinimise = 'action-minimise',
  ActionMoreHorizontal = 'action-more_horizontal',
  ActionMoreVertical = 'action-more_vertical',
  ActionOpenInFull = 'action-open_in_full',
  ActionOpenInNewTab = 'action-open_in_new_tab',
  ActionPersonAdd = 'action-person_add',
  ActionPersonRemove = 'action-person_remove',
  ActionRedo = 'action-redo',
  ActionRefresh = 'action-refresh',
  ActionRemoveCircleOutline = 'action-remove_circle_outline',
  ActionRepeat = 'action-repeat',
  ActionSave = 'action-save',
  ActionSearch = 'action-search',
  ActionSearchNoResult = 'action-search_no_results',
  ActionShare = 'action-share',
  ActionShow = 'action-show',
  ActionSortByAlpha = 'action-sort_by_alpha',
  ActionSortUpDown = 'action-sort_up_down',
  ActionSortUpdown = 'action-sort_updown',
  ActionSort = 'action-sort',
  ActionSwap = 'action-swap',
  ActionToggleOff = 'action-toggle_off',
  ActionToggleOn = 'action-toggle_on',
  ActionTransfer = 'action-transfer',
  ActionUndo = 'action-undo',
  ActionUpload = 'action-upload',
  BusinessLocalCompany = 'business_local_company',
  BusinessApprovedLiquidator = 'business-approved_liquidator',
  BusinessBusiness = 'business-business',
  BusinessForeignCompany = 'business-foreign_company',
  BusinessGroupOfCompanies = 'business-group_of_companies',
  BusinessLimitedLiabilityPartnership = 'business-limited_liability_partnership',
  BusinessLimitedPartnership = 'business-limited_partnership',
  BusinessPublicAccountingFirm = 'business-public_accounting_firm',
  BusinessPublicAccounting = 'business-public_accounting',
  DocumentDocument = 'document-document',
  DocumentFolder = 'document-folder',
  DocumentFolderShared = 'document-folder_shared',
  DocumentImage = 'document-image',
  DocumentMedia = 'document-media',
  DocumentPdf = 'document-pdf',
  DocumentPrint = 'document-print',
  DocumentProfileTag = 'document-profile_tag',
  DocumentQuote = 'document-quote',
  DocumentFillingBox = 'document-filing_box',
  GeneralAccount = 'general-account',
  GeneralAction = 'general-action',
  GeneralBarChart = 'general-bar_chart',
  GeneralCalendar = 'general-calendar',
  GeneralAnnualCalendar = 'general-annual_calendar',
  GeneralCheck = 'general-check',
  GeneralClock = 'general-clock',
  GeneralCreditCard = 'general-credit_card',
  GeneralDirections = 'general-directions',
  GeneralEmpty = 'general-empty',
  GeneralEnquiry = 'general-enquiry',
  GeneralHelp = 'general-help',
  GeneralHistory = 'general-history',
  GeneralHome = 'general-home',
  GeneralInfo = 'general-info',
  GeneralLightBulb = 'general-light_bulb',
  GeneralLoading = 'general-loading',
  GeneralLocation = 'general-location',
  GeneralLock = 'general-lock',
  GeneralLogin = 'general-login',
  GeneralMail = 'general-mail',
  GeneralMailOpen = 'general-mail_open',
  GeneralMap = 'general-map',
  GeneralMedia = 'general-media',
  GeneralMessage = 'general-message',
  GeneralMicrosoftDynamics = 'general-microsoft_dynamics',
  GeneralMoney = 'general-money',
  GeneralNotification = 'general-notification',
  GeneralPhone = 'general-phone',
  GeneralPieChart = 'general-pie_chart',
  GeneralPlane = 'general-plane',
  GeneralRestricted = 'general-restricted',
  GeneralRocket = 'general-rocket',
  GeneralSettings = 'general-settings',
  GeneralThumbsUp = 'general-thumbs_up',
  GeneralTimer = 'general-timer',
  GeneralUpdate = 'general-update',
  GeneralUpdatePerson = 'general-update_person',
  GeneralVerifiedBadge = 'general-verified_badge',
  GeneralVerifiedShield = 'general-verified_shield',
  GeneralWalk = 'general-walk',
  GeneralDashboard = 'general-dashboard',
  GeneralItemsCheck = 'general-items_check',
  IndustriesBiotech = 'industries-biotech',
  IndustriesFnb = 'industries-fnb',
  IndustriesHotel = 'industries-hotel',
  NavigationArrowBack = 'navigation-arrow_back',
  NavigationArrowDown = 'navigation-arrow_down',
  NavigationArrowDropDown = 'navigation-arrow_drop_down',
  NavigationArrowDropUp = 'navigation-arrow_drop_up',
  NavigationArrowForward = 'navigation-arrow_forward',
  NavigationArrowLeft = 'navigation-arrow_left',
  NavigationArrowRight = 'navigation-arrow_right',
  NavigationArrowUp = 'navigation-arrow_up',
  NavigationChevronLeft = 'navigation-chevron_left',
  NavigationChevronRight = 'navigation-chevron_right',
  NavigationDoubleChevronLeft = 'navigation-double_chevron_left',
  NavigationDoubleChevronRight = 'navigation-double_chevron_right',
  NavigationExpandLess = 'navigation-expand_less',
  NavigationExpandMore = 'navigation-expand_more',
  NavigationMenu = 'navigation-menu',
  RegistryAnnualFiling = 'registry-annual_filing',
  RegistryChargeRegistration = 'registry-charge_registration',
  RegistryCloseALocalCompany = 'registry-close_a_local_company',
  RegistryMakeChanges = 'registry-make_changes',
  RegistryStartCompany = 'registry-start_company',
  RegistryUpdateShareInfo = 'registry-update_share_info',
  StateError = 'state-error',
  StateInformative = 'state-informative',
  StateSuccess = 'state-success',
  StateWarning = 'state-warning',
  TechAPI = 'tech-API',
  TechCode = 'tech-code',
  TechDataPrivacy = 'tech-data_privacy',
  TechDatasets = 'tech-datasets',
  TechEIQ = 'tech-EIQ',
  TechFIQ = 'tech-FIQ',
  TechSecurity = 'tech-security',
  TechTokens = 'tech-tokens',
  TechWifiOff = 'tech-wifi_off',
  TechWifi = 'tech-wifi',
  ToggleCheckboxCheckedFill = 'toggle-checkbox_checked_fill',
  ToggleCheckboxCheckedOutline = 'toggle-checkbox_checked_outline',
  ToggleCheckboxIndeterminateFill = 'toggle-checkbox_indeterminate_fill',
  ToggleCheckboxIndeterminateOutline = 'toggle-checkbox_indeterminate_outline',
  ToggleCheckboxUnchecked = 'toggle-checkbox_unchecked',
  ToggleRadiobuttonSelected = 'toggle-radiobutton_selected',
  ToggleRadiobuttonUnselected = 'toggle-radiobutton_unselected',
  PaymentShoppingBag = 'payment-shopping_bag',
  PaymentEmptyCart = 'payment-empty_cart',
  PaymentPriceCheck = 'payment-price_check',
  ActionPersonCheck = 'action-person_check',
  DocumentEdit = 'document-edit',
  GeneralApprovalStamp = 'general-approval_stamp',
  DocumentExtracts = 'document-extracts',
  GeneralNotice = 'general-notice',
  GeneralPeopleSettings = 'general-people_settings',
  BusinessCompany = 'business-company',
  DocumentCertificate = 'document-certificate',
  DocumentRegisters = 'document-registers',
  GeneralPeople = 'general-people',
  PaymentRefund = 'payment-refund',
  DocumentZip = 'document-zip',
  DocumentPpt = 'document-ppt',
  GeneralUpdateCheck = 'general-update_check',
  GeneralGavel = 'general-gavel',
  GeneralCourt = 'general-court',
  GeneralTrendingDown = 'general-trending_down',
  ActionConvert = 'action-convert',
  GeneralEvent = 'general-event',
  BusinessCompanyCancel = 'business-company_cancel',
  BusinessSuitcaseCancel = 'business-suitcase_cancel',
  DocumentAddDoc = 'document-add_doc',
  DocumentPeopleProfile = 'document-people_profile',
}

export const SYSTEM_ICON_CODEPOINTS: { [key in SystemIcon]: string } = {
  [SystemIcon.ActionAddCircleOutline]: '61697',
  [SystemIcon.ActionAddToBookmark]: '61698',
  [SystemIcon.ActionAddToCart]: '61699',
  [SystemIcon.ActionAddToFavourites]: '61700',
  [SystemIcon.ActionAdd]: '61701',
  [SystemIcon.ActionAddedToBookmark]: '61702',
  [SystemIcon.ActionAttach]: '61703',
  [SystemIcon.ActionBookmarks]: '61704',
  [SystemIcon.ActionCart]: '61705',
  [SystemIcon.ActionClear]: '61706',
  [SystemIcon.ActionClose]: '61707',
  [SystemIcon.ActionCopy]: '61708',
  [SystemIcon.ActionDeleteForever]: '61709',
  [SystemIcon.ActionDeleteSweep]: '61710',
  [SystemIcon.ActionDelete]: '61711',
  [SystemIcon.ActionDownloadComplete]: '61712',
  [SystemIcon.ActionDownload]: '61713',
  [SystemIcon.ActionEdit]: '61714',
  [SystemIcon.ActionEnter]: '61715',
  [SystemIcon.ActionFavourited]: '61716',
  [SystemIcon.ActionFilter]: '61717',
  [SystemIcon.ActionHide]: '61718',
  [SystemIcon.ActionMaximise]: '61719',
  [SystemIcon.ActionMinimise]: '61720',
  [SystemIcon.ActionMoreHorizontal]: '61721',
  [SystemIcon.ActionMoreVertical]: '61722',
  [SystemIcon.ActionOpenInFull]: '61723',
  [SystemIcon.ActionOpenInNewTab]: '61724',
  [SystemIcon.ActionPersonAdd]: '61725',
  [SystemIcon.ActionPersonRemove]: '61726',
  [SystemIcon.ActionRedo]: '61727',
  [SystemIcon.ActionRefresh]: '61728',
  [SystemIcon.ActionRemoveCircleOutline]: '61729',
  [SystemIcon.ActionSave]: '61730',
  [SystemIcon.ActionSearch]: '61731',
  [SystemIcon.ActionShare]: '61732',
  [SystemIcon.ActionShow]: '61733',
  [SystemIcon.ActionSortByAlpha]: '61734',
  [SystemIcon.ActionSortUpDown]: '61735',
  [SystemIcon.ActionSortUpdown]: '61736',
  [SystemIcon.ActionSort]: '61737',
  [SystemIcon.ActionSwap]: '61738',
  [SystemIcon.ActionToggleOff]: '61739',
  [SystemIcon.ActionToggleOn]: '61740',
  [SystemIcon.ActionUndo]: '61741',
  [SystemIcon.ActionUpload]: '61742',
  [SystemIcon.BusinessLocalCompany]: '61743',
  [SystemIcon.BusinessApprovedLiquidator]: '61744',
  [SystemIcon.BusinessBusiness]: '61745',
  [SystemIcon.BusinessForeignCompany]: '61746',
  [SystemIcon.BusinessGroupOfCompanies]: '61747',
  [SystemIcon.BusinessLimitedLiabilityPartnership]: '61748',
  [SystemIcon.BusinessLimitedPartnership]: '61749',
  [SystemIcon.BusinessPublicAccountingFirm]: '61750',
  [SystemIcon.BusinessPublicAccounting]: '61751',
  [SystemIcon.DocumentDocument]: '61752',
  [SystemIcon.DocumentFolder]: '61753',
  [SystemIcon.DocumentImage]: '61754',
  [SystemIcon.DocumentMedia]: '61755',
  [SystemIcon.DocumentPdf]: '61756',
  [SystemIcon.DocumentPrint]: '61757',
  [SystemIcon.DocumentQuote]: '61758',
  [SystemIcon.GeneralAccount]: '61759',
  [SystemIcon.GeneralAction]: '61760',
  [SystemIcon.GeneralBarChart]: '61761',
  [SystemIcon.GeneralCalendar]: '61762',
  [SystemIcon.GeneralCheck]: '61763',
  [SystemIcon.GeneralClock]: '61764',
  [SystemIcon.GeneralCreditCard]: '61765',
  [SystemIcon.GeneralDirections]: '61766',
  [SystemIcon.GeneralEmpty]: '61767',
  [SystemIcon.GeneralHelp]: '61768',
  [SystemIcon.GeneralHistory]: '61769',
  [SystemIcon.GeneralHome]: '61770',
  [SystemIcon.GeneralInfo]: '61771',
  [SystemIcon.GeneralLightBulb]: '61772',
  [SystemIcon.GeneralLoading]: '61773',
  [SystemIcon.GeneralLocation]: '61774',
  [SystemIcon.GeneralLock]: '61775',
  [SystemIcon.GeneralLogin]: '61776',
  [SystemIcon.GeneralMail]: '61777',
  [SystemIcon.GeneralMap]: '61778',
  [SystemIcon.GeneralMedia]: '61779',
  [SystemIcon.GeneralMessage]: '61780',
  [SystemIcon.GeneralMicrosoftDynamics]: '61781',
  [SystemIcon.GeneralMoney]: '61782',
  [SystemIcon.GeneralNotification]: '61783',
  [SystemIcon.GeneralPhone]: '61784',
  [SystemIcon.GeneralPieChart]: '61785',
  [SystemIcon.GeneralPlane]: '61786',
  [SystemIcon.GeneralRestricted]: '61787',
  [SystemIcon.GeneralSettings]: '61788',
  [SystemIcon.GeneralThumbsUp]: '61789',
  [SystemIcon.GeneralTimer]: '61790',
  [SystemIcon.GeneralUpdate]: '61791',
  [SystemIcon.GeneralVerifiedBadge]: '61792',
  [SystemIcon.GeneralVerifiedShield]: '61793',
  [SystemIcon.GeneralWalk]: '61794',
  [SystemIcon.IndustriesBiotech]: '61795',
  [SystemIcon.IndustriesFnb]: '61796',
  [SystemIcon.IndustriesHotel]: '61797',
  [SystemIcon.NavigationArrowBack]: '61798',
  [SystemIcon.NavigationArrowDown]: '61799',
  [SystemIcon.NavigationArrowDropDown]: '61800',
  [SystemIcon.NavigationArrowDropUp]: '61801',
  [SystemIcon.NavigationArrowForward]: '61802',
  [SystemIcon.NavigationArrowLeft]: '61803',
  [SystemIcon.NavigationArrowRight]: '61804',
  [SystemIcon.NavigationArrowUp]: '61805',
  [SystemIcon.NavigationChevronLeft]: '61806',
  [SystemIcon.NavigationChevronRight]: '61807',
  [SystemIcon.NavigationDoubleChevronLeft]: '61808',
  [SystemIcon.NavigationDoubleChevronRight]: '61809',
  [SystemIcon.NavigationExpandLess]: '61810',
  [SystemIcon.NavigationExpandMore]: '61811',
  [SystemIcon.RegistryAnnualFiling]: '61812',
  [SystemIcon.RegistryChargeRegistration]: '61813',
  [SystemIcon.RegistryCloseALocalCompany]: '61814',
  [SystemIcon.RegistryMakeChanges]: '61815',
  [SystemIcon.RegistryStartCompany]: '61816',
  [SystemIcon.RegistryUpdateShareInfo]: '61817',
  [SystemIcon.StateError]: '61818',
  [SystemIcon.StateInformative]: '61819',
  [SystemIcon.StateSuccess]: '61820',
  [SystemIcon.StateWarning]: '61821',
  [SystemIcon.ToggleCheckboxCheckedFill]: '61822',
  [SystemIcon.ToggleCheckboxCheckedOutline]: '61823',
  [SystemIcon.ToggleCheckboxIndeterminateFill]: '61824',
  [SystemIcon.ToggleCheckboxIndeterminateOutline]: '61825',
  [SystemIcon.ToggleCheckboxUnchecked]: '61826',
  [SystemIcon.ToggleRadiobuttonSelected]: '61827',
  [SystemIcon.ToggleRadiobuttonUnselected]: '61828',
  [SystemIcon.ActionSearchNoResult]: '61829',
  [SystemIcon.GeneralItemsCheck]: '61830',
  [SystemIcon.GeneralMailOpen]: '61831',
  [SystemIcon.NavigationMenu]: '61832',
  [SystemIcon.PaymentShoppingBag]: '61833',
  [SystemIcon.DocumentFolderShared]: '61834',
  [SystemIcon.GeneralDashboard]: '61835',
  [SystemIcon.TechAPI]: '61836',
  [SystemIcon.TechCode]: '61837',
  [SystemIcon.TechDataPrivacy]: '61838',
  [SystemIcon.TechDatasets]: '61839',
  [SystemIcon.TechEIQ]: '61840',
  [SystemIcon.TechFIQ]: '61841',
  [SystemIcon.TechSecurity]: '61842',
  [SystemIcon.TechTokens]: '61843',
  [SystemIcon.TechWifiOff]: '61844',
  [SystemIcon.TechWifi]: '61845',
  [SystemIcon.PaymentPriceCheck]: '61846',
  [SystemIcon.GeneralAnnualCalendar]: '61847',
  [SystemIcon.DocumentFillingBox]: '61848',
  [SystemIcon.ActionPersonCheck]: '61849',
  [SystemIcon.DocumentEdit]: '61850',
  [SystemIcon.GeneralApprovalStamp]: '61851',
  [SystemIcon.DocumentExtracts]: '61852',
  [SystemIcon.GeneralUpdatePerson]: '61853',
  [SystemIcon.GeneralNotice]: '61854',
  [SystemIcon.GeneralPeopleSettings]: '61855',
  [SystemIcon.BusinessCompany]: '61856',
  [SystemIcon.PaymentEmptyCart]: '61857',
  [SystemIcon.ActionRepeat]: '61858',
  [SystemIcon.GeneralEnquiry]: '61859',
  [SystemIcon.DocumentCertificate]: '61860',
  [SystemIcon.DocumentProfileTag]: '61861',
  [SystemIcon.DocumentRegisters]: '61862',
  [SystemIcon.GeneralPeople]: '61863',
  [SystemIcon.PaymentRefund]: '61864',
  [SystemIcon.GeneralRocket]: '61865',
  [SystemIcon.ActionTransfer]: '61866',
  [SystemIcon.DocumentZip]: '61867',
  [SystemIcon.DocumentPpt]: '61868',
  [SystemIcon.GeneralUpdateCheck]: '61869',
  [SystemIcon.GeneralGavel]: '61870',
  [SystemIcon.GeneralCourt]: '61871',
  [SystemIcon.GeneralTrendingDown]: '61872',
  [SystemIcon.ActionConvert]: '61873',
  [SystemIcon.GeneralEvent]: '618674',
  [SystemIcon.BusinessCompanyCancel]: '61875',
  [SystemIcon.BusinessSuitcaseCancel]: '61876',
  [SystemIcon.DocumentAddDoc]: '61877',
  [SystemIcon.DocumentPeopleProfile]: '61878',
};
